import { CloseOutlined } from '@ant-design/icons'
import type { FtpTransferTask } from './types'
import { formatFileSize } from './utils'
import styles from './FtpClient.module.css'

interface FtpTransferPanelProps {
  tasks: FtpTransferTask[]
  open: boolean
  onToggle: () => void
  onClearDone: () => void
}

function statusLabel(task: FtpTransferTask) {
  switch (task.status) {
    case 'pending':
      return 'В очереди'
    case 'running':
      return `${task.progress}%`
    case 'done':
      return 'Готово'
    case 'error':
      return task.error || 'Ошибка'
    default:
      return ''
  }
}

export function FtpTransferPanel({ tasks, open, onToggle, onClearDone }: FtpTransferPanelProps) {
  const active = tasks.filter((t) => t.status === 'pending' || t.status === 'running').length
  const done = tasks.filter((t) => t.status === 'done' || t.status === 'error').length

  return (
    <div className={styles.transferPanel}>
      <div className={styles.transferHeader} onClick={onToggle}>
        <span>
          Передачи {active > 0 ? `(${active} активных)` : ''}
        </span>
        <span>{open ? '▼' : '▲'}</span>
      </div>
      {open ? (
        <div className={styles.transferBody}>
          {tasks.length === 0 ? (
            <div className={styles.transferEmpty}>Нет задач</div>
          ) : (
            <>
              <div className={styles.transferList}>
                {tasks.map((task) => (
                  <div key={task.id} className={styles.transferRow}>
                    <div className={styles.transferRowTop}>
                      <span className={styles.transferDir}>
                        {task.direction === 'upload' ? '↑' : '↓'}
                      </span>
                      <span className={styles.transferName} title={task.name}>
                        {task.name}
                      </span>
                      <span
                        className={
                          task.status === 'error'
                            ? styles.transferStatusError
                            : task.status === 'done'
                              ? styles.transferStatusDone
                              : styles.transferStatus
                        }
                      >
                        {statusLabel(task)}
                      </span>
                    </div>
                    {(task.status === 'running' || task.status === 'done') && (
                      <div className={styles.progressTrack}>
                        <div
                          className={styles.progressBar}
                          style={{ width: `${task.progress}%` }}
                        />
                      </div>
                    )}
                    {task.localFile && task.direction === 'upload' ? (
                      <span className={styles.transferMeta}>{formatFileSize(task.localFile.size)}</span>
                    ) : null}
                  </div>
                ))}
              </div>
              {done > 0 ? (
                <button type="button" className={styles.transferClear} onClick={onClearDone}>
                  <CloseOutlined /> Очистить завершённые
                </button>
              ) : null}
            </>
          )}
        </div>
      ) : null}
    </div>
  )
}
